import React from 'react';
import { useTranslation } from 'react-i18next';

interface VideoGenerateButtonProps {
  isGeneratingVideo: boolean;
  handleGenerateVideo: () => void;
  videoPrompt: string;
  setActiveTab: (tab: 'image' | 'video' | 'prompt') => void;
  onCancel?: () => void;
}

const VideoGenerateButton: React.FC<VideoGenerateButtonProps> = ({
  isGeneratingVideo,
  handleGenerateVideo,
  videoPrompt,
  setActiveTab,
  onCancel,
}) => {
  const { t } = useTranslation('aiGenerator');
  
  return (
    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '30px' }}>
      <button
        onClick={() => {
          // If onCancel is provided, close the modal; otherwise fall back to switching to image tab
          if (onCancel) {
            onCancel();
          } else {
            setActiveTab('image');
          }
        }}
        style={{
          padding: '12px 24px',
          border: '1px solid rgba(255,255,255,0.2)',
          backgroundColor: 'transparent',
          color: 'white',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '500'
        }}
      >
        {t('common.cancel')}
      </button>
      
      <button
        onClick={handleGenerateVideo}
        disabled={isGeneratingVideo || !videoPrompt.trim()}
        style={{
          padding: '12px 24px',
          background: isGeneratingVideo ? '#666' : 'linear-gradient(135deg, #8b5cf6, #e11d48)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: isGeneratingVideo ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          fontWeight: '500'
        }}
      >
        {isGeneratingVideo ? (
          <>
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid #ffffff40',
              borderTop: '2px solid white',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              display: 'inline-block',
              marginRight: '8px'
            }} />
            {t('video.generating')}
          </>
        ) : (
          <>{t('video.generate')}</>
        )}
      </button>
    </div>
  );
};

export default VideoGenerateButton;